// angular
//   .module('HeroPRO')
//   .controller('HEROCountersignController', HEROCountersignController);

import _ from 'lodash';
import './appDetailCommon.scss';
import './heroCountersign.scss';

/* @ngInject */
export default function HEROCountersignController($stateParams, $filter, $analytics, DocumentLink, FRInformationFactory, Timestamp, FRDisbursementsFactory, FRClosingFactory, raSpinnerService, WalkthroughFactory) {
    const vm = this;
    const advancePaymentDisbursementTypeId = 3;
    vm.stepSubjects = [];
    vm.stepDescription = '';
    vm.advancePaymentHistory = null;
    vm.advancePaymentCollapsed = true;
    vm.appDetails = {};

    // Flags
    vm.hasBypassedNTP = false;

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */

    FRInformationFactory.getFundingRequestInformationPromise().then(() => {
        vm.appDetails = FRInformationFactory.getAppInfo();
    });

    FRDisbursementsFactory.getDisbursementStatusHistory({ FundingRequestId: $stateParams.appId, DisbursementType: advancePaymentDisbursementTypeId }).then((response) => {
        setAdvancePaymentInfo(response.data);
    });

    function setAdvancePaymentInfo(advancePaymentHistoryData) {
        if (!!advancePaymentHistoryData.Data && advancePaymentHistoryData.Data.length > 0) {
            vm.advancePaymentHistory = {};
            vm.advancePaymentHistory.disbursementStatusInfos = advancePaymentHistoryData.Data[0].DisbursementStatusInfos;
            vm.advancePaymentHistory.disbursementAmount = advancePaymentHistoryData.Data[0].DisbursementAmount;
            vm.advancePaymentHistory.latestDisbursementStatus = vm.advancePaymentHistory.disbursementStatusInfos[vm.advancePaymentHistory.disbursementStatusInfos.length - 1];

            switch (vm.advancePaymentHistory.latestDisbursementStatus.DisbursementStatusId) {
            case 1: // Created
                var apDate = new Date(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate);
                apDate.setDate(apDate.getDate() + 3);
                vm.advancePaymentHistory.headerTitle = `Advance Payment expected between ${$filter('date')(
                    vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate,
                    'shortDate',
                )} - ${$filter('date')(apDate, 'shortDate')}`;
                break;
            case 2: // Disbursed/Sent
                vm.advancePaymentHistory.headerTitle = `Advance Payment sent on ${$filter('date')(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate, 'shortDate')}`;
                break;
            case 3: // Repaid
            case 6: // HERO Funded
                vm.advancePaymentHistory.headerTitle = `${$filter('currency')(
                    vm.advancePaymentHistory.disbursementAmount, '$',
                    2,
                )} Advance Payment was repaid on ${$filter('date')(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate, 'shortDate')}`;
                break;
            case 4: // Cancelled
                vm.advancePaymentHistory.headerTitle = `${$filter('currency')(vm.advancePaymentHistory.disbursementAmount, '$', 2)} Advance Payment cancelled`;
                break;
            case 5: // Invoiced
                vm.advancePaymentHistory.headerTitle = `${$filter('currency')(
                    vm.advancePaymentHistory.disbursementAmount, '$',
                    2,
                )} Advance Payment invoiced on ${$filter('date')(vm.advancePaymentHistory.latestDisbursementStatus.CreatedDate, 'shortDate')}`;
                break;
            }
        }
    }


    /* -----  End of Private Functions  ------*/


    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.confirmProjectComplete = function () {
        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.confirmProjectComplete().then((response) => {
            FRInformationFactory.setStateMachineData(
                response.data.PipelineStageId,
                response.data.FundingRequestPipelineStageId, response.data.LoanStateId,
                response.data.FundingRequestStateId,
            );
            FRClosingFactory.setProjectDetails(_.omit(response.data, 'FundingRequestId', 'LoanStateId'));
            FRClosingFactory.setProjectDetailsConfirmed();
            WalkthroughFactory.loadWalkthrough();
            raSpinnerService.hide('walkthroughSpinner');
        });
    };

    vm.isCountersignNTPComplete = function () {
        return (vm.appDetails.isIssuerReviewed || vm.appDetails.isCountersigned) && vm.appDetails.isNTPSent;
    };

    vm.clickContinue = function () {
        vm.hasBypassedNTP = true;
    };
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/startWork/HERO-Countersign/HEROCountersignController.js